import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ENERGY_STORAGE_KEY } from '@windrop/ui';
import { App } from './app';
import { applyConsoleTheme, watchSystemTheme } from './lib/theme';
import './styles/app.css';

// Console default is calm (operators are not the audience for theatre, §13.2) — seeded once, never forced:
// the operator's own preference in Display settings always wins (D14 precedence: user choice first).
try {
  if (!localStorage.getItem(ENERGY_STORAGE_KEY)) localStorage.setItem(ENERGY_STORAGE_KEY, 'CALM');
} catch {
  /* storage unavailable (private mode): the provider falls back to the OS preference */
}

// Light-leaning admin theme (D-2601): "system" resolves to light unless the OS prefers dark; applied before the
// first paint so kit and console tokens agree. No inline script (CSP).
applyConsoleTheme();
watchSystemTheme();

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
